import { createApp } from 'vue'
import './preload'; // Importing preload file for loading css on preload
import App from './App.vue'
import router from './router'
import store from './store'
createApp(App).use(store).use(router).mount('#app')
